jQuery(document).ready(function($) {
	if (!window.WebAssessmentCharts) {
		window.WebAssessmentCharts = {}; // Create namespace if it doesn't exist
	}

	// Strips the `NIST-SP-800-171-<major>-<minor>-` framework/version prefix
	// so that numeric control IDs like `NIST-SP-800-171-4-0-03.05.03` become `03.05.03`.
	const NIST_800_171_PREFIX_REGEX = /^NIST-SP-800-171-\d+-\d+-/i;
	function stripNist800171Prefix(controlId) {
		if (typeof controlId !== 'string') {
			return controlId;
		}
		return controlId.replace(NIST_800_171_PREFIX_REGEX, '');
	}

	// Extracts the family key `<major>.<minor>` (e.g. "03.05" from "03.05.03").
	// Zero-padding is preserved as-is since it matches the dashboard
	// `data-subdomain` attributes and the topicOrder keys.
	function getNist800171Category(controlId) {
		const numericId = stripNist800171Prefix(controlId);
		if (!numericId) {
			return null;
		}
		const parts = numericId.split('.');
		if (parts.length < 2) {
			return null;
		}
		return parts[0] + '.' + parts[1];
	}

	let projectID;
	if ($('body').hasClass('single-projects')) {
		const pathParts = window.location.pathname.split('/projects/');
		if (pathParts.length > 1) {
			projectID = pathParts[1].split('/')[0];
			console.log('Extracted projectID:', projectID);
		}
	}

	WebAssessmentCharts.fetchProjectChartData = fetchProjectChartData;
	var homeFrameworkProcessUniqueItems = processUniqueItemsCIS;

	WebAssessmentCharts.fetchDataAndCalculateScores = async function (projectID) {
		const pathParts = window.location.pathname.split('/projects/');
		if (pathParts.length > 1) {
			projectID = pathParts[1].split('/')[0];
		}

		try {
			const projectDataPromise = WebAssessmentCharts.fetchProjectChartData(projectID);
			const [projectData] = await Promise.all([projectDataPromise]);

			if (!projectData || !Array.isArray(projectData)) {
				console.error('Project data is missing or not structured as expected:', projectData);
				return;
			}

			const projectItems = projectData;
			const processedItems = homeFrameworkProcessUniqueItems(projectItems);
			console.log('Processed Items:', processedItems);

			try {
				const response = await jQuery.ajax({
					url: controlsData.ajax_url,
					type: 'POST',
					dataType: 'json',
					data: {
						action: 'api_action',
						year: '2024',
						apis: ['CS'],
						CSLstandardID: 'NIST-SP-800-171-4-0'
					}
				});

				console.log('NIST SP 800-171 Standards response structure:', JSON.stringify(response, null, 2));
				WebAssessmentCharts.nist800171StandardData = response;

				if (!response.CS || !response.CS.Items) {
					console.error('Invalid NIST SP 800-171 standards response structure:', response);
					return;
				}

				WebAssessmentCharts.NIST800171REV3(processedItems, response);

			} catch (error) {
				console.error('Error fetching NIST SP 800-171 standards:', error);
				WebAssessmentCharts.NIST800171REV3(processedItems);
			}

		} catch (error) {
			console.error('Error processing data:', error);
		} finally {
			$('.modal-body .loader').hide();
		}
	};

	if (typeof WebAssessmentCharts.registerHomeDashboardFetcher === 'function') {
		WebAssessmentCharts.registerHomeDashboardFetcher('nist-800-171-rev3', WebAssessmentCharts.fetchDataAndCalculateScores);
	}

	WebAssessmentCharts.calculateMaturityScore = calculateMaturityScore;
	WebAssessmentCharts.getMostRecentSafeguards = getMostRecentSafeguards;
	WebAssessmentCharts.processUniqueItems = processUniqueItemsCIS;

	WebAssessmentCharts.calculateNist800171CategoryAverages = function(items, standardData) {
		const categoryScores = {};
		const categoryPotentialCounts = {};

		if (standardData && standardData.CS && standardData.CS.Items) {
			standardData.CS.Items.forEach(control => {
				if (control.controlid && control.controlid.S) {
					const category = getNist800171Category(control.controlid.S);
					if (category === null || category === undefined) {
						return;
					}
					if (!categoryPotentialCounts[category]) {
						categoryPotentialCounts[category] = 0;
					}
					categoryPotentialCounts[category]++;
				}
			});
		}
		console.log('NIST SP 800-171 Category potential counts: ', categoryPotentialCounts);

		Object.keys(categoryPotentialCounts).forEach(category => {
			categoryScores[category] = {
				total: 0,
				count: 0,
				notApplicableCount: 0,
				totalItems: 0,
				potentialCount: categoryPotentialCounts[category]
			};
		});

		items.forEach(item => {
			if (!item.safeguardid || !item.safeguardid.S) {
				return;
			}
			const category = getNist800171Category(item.safeguardid.S);
			if (category === null || category === undefined) {
				return;
			}
			const maturityScore = item.maturityscore;
			const policyStatus = item.policystatus ? item.policystatus.N : null;

			if (!categoryScores[category]) {
				categoryScores[category] = {
					total: 0,
					count: 0,
					notApplicableCount: 0,
					totalItems: 0,
					potentialCount: categoryPotentialCounts[category] || 0
				};
			}

			categoryScores[category].totalItems++;

			if (policyStatus === "1") {
				categoryScores[category].notApplicableCount++;
			} else if (maturityScore !== null) {
				categoryScores[category].total += maturityScore;
				categoryScores[category].count++;
			}
		});

		const averages = {};
		Object.keys(categoryScores).forEach(category => {
			const { total, count, notApplicableCount, totalItems, potentialCount } = categoryScores[category];

			if (notApplicableCount === totalItems && totalItems > 0) {
				averages[category] = null;
			} else {
				const applicableCount = potentialCount ? (potentialCount - notApplicableCount) : count;
				averages[category] = applicableCount > 0 ? total / applicableCount : 0;
				console.log(`NIST SP 800-171 Category ${category}: total=${total}, potentialCount=${potentialCount}, notApplicableCount=${notApplicableCount}, applicableCount=${applicableCount}, average=${averages[category]}`);
			}
		});

		console.log('NIST SP 800-171 Category averages: ', averages);
		return averages;
	};

	WebAssessmentCharts.NIST800171REV3 = function(items, standardData) {
		console.log('Starting NIST800171REV3 function...');
		const tableBody = document.querySelector('#nist-800-171-rev3 tbody');
		if (!tableBody) {
			console.error('NIST SP 800-171 Table body not found.');
			return;
		}

		const originalIndices = new Map();
		Array.from(tableBody.rows).forEach((row, index) => {
			originalIndices.set(row, index);
		});

		const allSafeguards = new Map();
		if (standardData && standardData.CS && standardData.CS.Items) {
			standardData.CS.Items.forEach(control => {
				if (control.controlid && control.controlid.S) {
					allSafeguards.set(control.controlid.S, {
						safeguardid: { S: control.controlid.S },
						policystatus: { N: "0" },
						maturityscore: 0
					});
				}
			});
		}

		const processedItems = homeFrameworkProcessUniqueItems(items);
		processedItems.forEach(item => {
			if (item && item.safeguardid && item.safeguardid.S) {
				allSafeguards.set(item.safeguardid.S, item);
			}
		});

		const mergedItems = Array.from(allSafeguards.values());
		console.log('NIST SP 800-171 merged items (including unanswered):', mergedItems);

		const averageScores = WebAssessmentCharts.calculateNist800171CategoryAverages(mergedItems, standardData);

		const rowsToRemove = [];

		Array.from(tableBody.rows).forEach(row => {
			row.style.display = '';
		});

		// Look up each row by its `data-subdomain` attribute (e.g. "03.01").
		Object.keys(averageScores).forEach(category => {
			const row = tableBody.querySelector(`tr[data-subdomain="${category}"]`);
			if (row) {
				const averageScore = averageScores[category];
				const scoreCell = row.cells[1];

				if (averageScore === null) {
					rowsToRemove.push(row);
				} else {
					const scaledScore = averageScore * 5; // Scale to out of 5
					scoreCell.textContent = scaledScore.toFixed(2);
					console.log(`Updated NIST SP 800-171 family ${category} with averageScore:`, scaledScore.toFixed(2));
				}
			} else {
				console.warn(`NIST SP 800-171 row not found for family ${category}`);
			}
		});

		rowsToRemove.forEach(row => {
			row.remove();
		});

		let totalScore = 0;
		let scoreCount = 0;
		Array.from(tableBody.rows).forEach((row) => {
			const scoreText = row.cells[1].textContent;
			const score = parseFloat(scoreText);
			if (!isNaN(score)) {
				totalScore += score;
				scoreCount++;
			}
		});

		const maturityRatingRow = $('#nist-800-171-rev3 .light-background td');
		if (maturityRatingRow.length > 0 && scoreCount > 0) {
			const overallMaturity = totalScore / scoreCount;
			WebAssessmentCharts.overallNIST800171Rev3maturity = overallMaturity;

			maturityRatingRow.text(overallMaturity.toFixed(2));
			$('.audit-overall-value').text(overallMaturity.toFixed(2));
			$('.nist-800-171-rev3-overall-value').text(overallMaturity.toFixed(2));
			console.log(`Updated NIST SP 800-171 overall maturity rating to ${overallMaturity.toFixed(2)}`);

			$('.spinner-border').hide();
			$('.mark-complete-modal-buttons').show();
		} else {
			console.error('Error: No scores found or maturity rating row not found in the NIST SP 800-171 table.');
		}

		$('.nist-800-171-rev3-container').show();
		WebAssessmentCharts.createChartFromTable('nist-800-171-rev3', 'nist-800-171-rev3-chart', charts, true);

		rowsToRemove.forEach(row => {
			const originalIndex = originalIndices.get(row);
			if (originalIndex !== undefined) {
				tableBody.insertBefore(row, tableBody.rows[originalIndex] || null);
				row.style.display = 'none';
			}
		});
	};

	var charts = {};

	$('a.view-table').on('click', function (e) {
		e.preventDefault();
		var $button = $(this);
		var card = $button.closest('.card');
		var dataTable = card.find('.data');
		var chart = card.find('.chart');

		var isModal = $('body').hasClass('single-projects');
		var $scrollContainer = isModal ? $('.modal.show .modal-body') : $('html, body');

		dataTable.toggle();

		setTimeout(function() {
			var $targetElement;
			var headerOffset = 20;

			if (dataTable.is(':visible')) {
				$button.text('Hide Table');
				$targetElement = dataTable;
			} else {
				$button.text('View Table');
				$targetElement = card;
			}

			var currentScrollTop = $scrollContainer.scrollTop();
			var targetTop = $targetElement[0].getBoundingClientRect().top;
			var containerTop = isModal ? $scrollContainer[0].getBoundingClientRect().top : 0;

			var scrollOffset = targetTop - containerTop - headerOffset;
			var newScrollTop = currentScrollTop + scrollOffset;

			$scrollContainer.scrollTop(newScrollTop);

		}, 10);

		jQuery('.dashboard-selection').select2('open');
		jQuery('.dashboard-selection').select2('close');
	});

	viewResultsProject = window.location.href;
	let currentProjectID = '';

	if (viewResultsProject.includes('#')) {
		currentProjectID = viewResultsProject.split('#')[1];
	}

	if (!currentProjectID) {
		const projectPath = viewResultsProject.split('/projects/');
		if (projectPath.length > 1) {
			currentProjectID = projectPath[1];
		}
	}

	$('.view-results').on('click', function() {
		$('.modal-body .loader').show();
		let projectPath = viewResultsProject.split('/projects/');
		if (projectPath.length > 1) {
			currentProjectID = projectPath[1].split(/[?#]/)[0];
			WebAssessmentCharts.fetchDataAndCalculateScores(currentProjectID);
		}
	});

	$(document).on('shown.bs.modal', '#projectCompleteModal', function (event) {
		if (currentProjectID) {
			console.log('Project Complete Modal detected with Project ID:', currentProjectID);
			WebAssessmentCharts.fetchDataAndCalculateScores(currentProjectID);
		} else {
			console.error('Project ID not found for #projectCompleteModal');
		}
	});
});
